/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { LocoDetail } from '../../../core/model/loco-detail.model';

/**
 * @export
 * @class LmsLocoFuelSvgComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-fuel-svg',
  templateUrl: './lms-loco-fuel-svg.component.html',
  styleUrls: ['./lms-loco-fuel-svg.component.scss']
})
export class LmsLocoFuelSvgComponent implements OnInit, OnDestroy, OnChanges {

  @Input() locoData: LocoDetail;
  fuelLevelType: number;

  /**
   * Creates an instance of LmsLocoFuelSvgComponent.
   *
   * @memberOf LmsLocoFuelSvgComponent
   */
  constructor() { }

  /**
   * This is used to calculate the fuel level Percentage
   * @memberOf LmsLocoFuelSvgComponent
   */
  ngOnInit() {
    this.calculateFuelPer(this.locoData);
  }

  ngOnChanges() {
    this.calculateFuelPer(this.locoData);
  }
  /**
   * @memberOf LmsLocoFuelSvgComponent
   */
  ngOnDestroy() {
  }

  /**
     * This Method is used to calculate fuel Level Percentage to be shown in Fuel Image
     * @param {LocoDetail} locoData
     * @returns {number}
     * @memberOf LmsLocoFuelComponent
     */
  calculateFuelPer(locoData: LocoDetail) {
    let fuelLevelPer: number;
    if (locoData) {
      if (!((!locoData.miles || locoData.miles === '') || (!locoData.mixedRange || locoData.mixedRange === ''))) {
        fuelLevelPer = (Number(locoData.miles) / Number(locoData.mixedRange)) * 100;
        this.fuelLevelType = this.calculateFuelLevelType(fuelLevelPer);
      } else if (!((!locoData.fuelLevel || locoData.fuelLevel === '') || (!locoData.capacity || locoData.capacity === ''))) {
        fuelLevelPer = (Number(locoData.fuelLevel) / Number(locoData.capacity)) * 100;
        this.fuelLevelType = this.calculateFuelLevelType(fuelLevelPer);
      } else {
        this.fuelLevelType = 4;
      }
    }
  }

  /**
   * This method is used to calculate Fuel type
   * @param {number} fuelLevelPer
   * @returns {number}
   * @memberOf LmsLocoFuelComponent
   */
  private calculateFuelLevelType(fuelLevelPer: number): number {
    if (fuelLevelPer > 0 && fuelLevelPer <= 25) {
      return 1;
    } else if (fuelLevelPer > 25 && fuelLevelPer <= 62.5) {
      return 2;
    } else if (fuelLevelPer > 62.5) {
      return 3;
    }
  }

}
